function FreshTime() {
        var endtime = new Date("2023/1/18,14:00:00"); 
        var nowtime = new Date(); 
        var lefttime = parseInt((endtime.getTime() - nowtime.getTime()) / 1000);
        d = parseInt(lefttime / 3600 / 24);
        h = parseInt((lefttime / 3600) % 24);
        m = parseInt((lefttime / 60) % 60);
        s = parseInt(lefttime % 60);
		var d= (d < 10 ? "0" + (d) : d) + "";

		var h= (h < 10 ? "0" + (h) : h) + "";

		var m= (m < 10 ? "0" + (m) : m) + "";

		var s= (s < 10 ? "0" + (s) : s);

         document.getElementById("LeftTime").innerHTML ="<span class='runon-down'>"+ d + "</span><span class='runon-down'>" + h + "</span>:<span class='runon-down'>" + m + "</span>:<span class='runon-down'>" + s + "</span>";
    }
    FreshTime()
    var sh;
    sh = setInterval(FreshTime, 1000);